import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core';
import Viewer from 'viewerjs';
import { NbDialogService } from '@nebular/theme';
import { ViewCell } from 'ng2-smart-table';

@Component({
  selector: 'app-video-modal',
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.scss']
})
export class VideoModalComponent implements OnInit, ViewCell, OnDestroy {
  @ViewChild('dialog') dialog!: TemplateRef<any>;

  @Input() set value(data: any) {
    this.data = data;
  }

  @Input() rowData: any;
  data: any;
  playVideo = false;

  constructor(private dialogService: NbDialogService) {}

  showVideo(dialog: TemplateRef<any>): void {
    this.playVideo = true;
    this.dialogService.open(dialog, {
      closeOnEsc: true,
      closeOnBackdropClick: true
    });
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {}
}
